import { render, staticRenderFns } from "./AuthorizationForm.vue?vue&type=template&id=4f3d5117&scoped=true&"
import script from "./AuthorizationForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizationForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authorization.css?vue&type=style&index=0&id=4f3d5117&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d5117",
  null
  
)

export default component.exports